import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Modal from "@mui/material/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {
  Paper,
  Table,
  withStyles,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Button from "@mui/material/Button";

import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import Loader from "../components/loader";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow:'scroll',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    paper: {
        marginTop: "2rem",
        padding: "0.5rem 2rem",
        width: "100%",
       
    },
    table: {
        maxWidth: "100%",
        margin: "auto",
        overflow:'scroll',
      
    },
    tableContainer: {
        marginTop: "2rem",
        position: "sticky",
        top: "200px",
        overflow:'scroll',
        
      
    },
    head: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "2rem",
    },
    toolbar: {
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
    },
    listStyle: {
        marginLeft: "20px",
    }
}));
const StyledTableCell:any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#0E3F6C",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);

type ModalProps = {
  loading: Boolean;
  openReportModal: boolean;
  setReportModal: Function;
  reportStatus: any;
};

const DosStatusModal: React.FC<ModalProps> = ({
  openReportModal,
  setReportModal,
  reportStatus,
  loading,
}) => {
  const classes = useStyles();
  const [openModel, setOpenModel] = React.useState(false);


  const handleClose = () => {
    setReportModal(false);
  };
  
  const handleModelClose = () => {
    setOpenModel(false);
  };




  console.log(reportStatus, "myDosData");

  return (
    <div>
      <TableContainer className={classes.tableContainer} component={Paper}>
        <Table stickyHeader aria-label="simple table">
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={openReportModal}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openReportModal}>
              <div
                className={classes.paper}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  marginTop: "20px",
                  height: "100%",
                  position: "sticky",
                }}
              >
                <Paper elevation={15} className={classes.paper}>
                  <TableContainer className={classes.table} component={Paper}>
                    <div className={classes.head}>
                      <h4
                        style={{
                          marginBottom: "1rem",
                        }}
                        id="transition-modal-title"
                      >
                        LIMS Report
                      </h4>
                      <CloseIcon onClick={() => setReportModal(false)} />
                    </div>
                    {loading ? (
                      <Loader />
                    ) : (
                      <Table aria-label="simple table">
                        <TableHead>
                          <StyledTableRow>
                            <StyledTableCell align="center">
                              Booking Id{" "}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Test Code : Test Name{" "}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Status{" "}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              User Name
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              Date
                            </StyledTableCell>
                          </StyledTableRow>
                        </TableHead>
                        <TableBody>
                          {reportStatus && reportStatus?.length > 0 &&
                            reportStatus.map((data: any, index: any) => (
                              <StyledTableRow key={index}>
                                <StyledTableCell
                                  style={{ height: "50px" }}
                                  align="center"
                                >
                                  {data?.ledgertransactionno}
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ height: "50px" }}
                                  align="center"
                                >
                                 {data?.test_id?.length > 0 ? data?.test_id[0]?.testCode : "" } : { data?.test_id?.length > 0 ? data?.test_id[0]?.testName : "" }
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ height: "50px" }}
                                  align="center"
                                >
                                  {data?.status}
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ height: "50px" }}
                                  align="center"
                                >
                                  {data?.username}
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ height: "50px" }}
                                  align="center"
                                >
                                  {new Date(data?.dtentry).toLocaleString()}
                                </StyledTableCell>
                              </StyledTableRow>
                            ))}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                </Paper>
              </div>
            </Fade>
          </Modal>
        </Table>
      </TableContainer>
    </div>
  );
};



export default DosStatusModal
